import styled from 'styled-components';

export const HoverIcon = styled.div`
	opacity: 0.3;
	&:hover {
		opacity: 1;
	}
`;

export const StyledLink = styled.div`
	cursor: pointer;
	&:hover {
		text-decoration: underline;
		color: ${props => props.theme.palette.secondary.main};
	}
`;

/** @deprecated Apply tokenized p to an existing component through its supported props or sx. Add Box only when a wrapper is needed. */
export const Padded = styled.div`
	padding: 1rem;
`;
/** @deprecated Apply tokenized py and px to an existing component through its supported props or sx. Add Box only when a wrapper is needed. */
export const PaddedHalfTop = styled.div`
	padding: 0.5rem 1rem;
`;

/** @deprecated Apply tokenized py to an existing component through its supported props or sx. Add Box only when a wrapper is needed. */
export const PaddedY = styled.div`
	padding: 1rem 0rem;
`;
/** @deprecated Apply tokenized px to an existing component through its supported props or sx. Add Box only when a wrapper is needed. */
export const PaddedX = styled.div`
	padding: 0rem 1rem;
`;

/** @deprecated Apply tokenized p to an existing component through its supported props or sx. Add Box only when a wrapper is needed. */
export const PaddedLarge = styled.div`
	padding: 2rem;
`;

/** @deprecated Apply tokenized p to an existing component through its supported props or sx. Add Box only when a wrapper is needed. */
export const HalfPadded = styled.div`
	padding: 0.5rem;
`;
/** @deprecated Apply tokenized py to an existing component through its supported props or sx. Add Box only when a wrapper is needed. */
export const HalfPaddedY = styled.div`
	padding: 0.5rem 0;
`;

/** @deprecated Apply tokenized py and px to an existing component through its supported props or sx. Add Box only when a wrapper is needed. */
export const PaddedLargeSide = styled.div`
	padding: 1rem 2rem;
`;
